export default [
  {
    path: '/veiculo/:veiculoId/funcionarios',
    name: 'VeiculoFuncionario',
    component: () => import('./VeiculoFuncionario'),
    meta: {
      domain: 'Veiculo',
      sidebar: false,
      icon: 'keyboard_backspace',
      title: 'Funcionários vinculados',
      routerBack: '/veiculos',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Veiculos/Funcionario/VeiculoFuncionarioRouter.js